import styled from 'styled-components'
import { colours } from '@qflow/theme'

export const LineItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: solid 1px ${colours.CLOUD_GREY};
  border-radius: 10px;

  padding: 0 1rem 1rem;
  margin-bottom: 1rem;
`

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const ShowRawWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 7px;
  margin-left: -10px;
`

export const DataToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 7px;
  border-bottom: solid 1px ${colours.CLOUD_GREY};
`

export const DataToggleItem = styled.div`
  line-height: 38px;
  font-weight: 500;

  &.active,
  &:hover {
    cursor: pointer;
    color: ${colours.TEAL};
    border-bottom: solid 2px ${colours.TEAL};
    margin-bottom: -1px;
  }

  &.disabled,
  &.disabled:hover {
    cursor: default;
    color: ${colours.BORDER_GREY};
    border-bottom: none;
    margin-bottom: 0;
  }
`

export const LineItemTitle = styled.summary`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
`
